import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import {Link} from "@mui/material";

import ArrowRightIcon from "components/icons/ArrowRightIcon";

import {black500, greyishBlue100} from "assets/jss/main";

ShowMoreButtonMobile.propTypes = {
    onClick: PropTypes.func,
    labelId: PropTypes.string,
};

function ShowMoreButtonMobile({onClick = () => {}, labelId = "dashboard.topProducts.showMore", ...props}) {
    return (
        <div style={{
            padding: '14px',
            display: 'flex',
            justifyContent: "center",
            background: '#fff',
            borderRadius:'12px',
            border: `1px solid ${greyishBlue100}`,

        }}>
            <Link
                component="button"
                onClick={onClick}
                sx={{
                    fontSize: "13px",
                    color: black500,
                    cursor: "pointer",
                    textDecoration: 'none',
                    display: 'flex',
                    alignItems: "center",
                }}
            >
                <b style={{marginRight: "8px"}}>
                    <FormattedMessage id={labelId} />
                </b>
                <ArrowRightIcon size={16}/>
            </Link>
        </div>
    );
}

export default ShowMoreButtonMobile;
